import { create } from 'zustand';
import type { AuthUser } from './types';

interface AuthState {
  user: AuthUser | null;
  status: 'idle' | 'loading' | 'authenticated' | 'unauthenticated';
  setUser: (u: AuthUser) => void;
  clear: () => void;
  setStatus: (s: AuthState['status']) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  setUser: (user) => set({ user, status: 'authenticated' }),
  clear: () => set({ user: null, status: 'unauthenticated' }),
  setStatus: (status) => set({ status }),
}));
